import React, { FC } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Image from "@/components/ui/Image/Image";
import { EditorialBoxProps } from "@/types";

interface Props {
  editorialBox: EditorialBoxProps;
}
// @TODO: Manage Click

const EditorialBox: FC<Props> = ({ editorialBox }) => {
  return (
    <button
      className="md:col-span-2 aspect-4-3 md:aspect-16-9 mb-l md:mb-0 rounded-lg p-l flex  flex-col justify-end md:justify-between relative text-left group overflow-hidden"
      onClick={() => console.log("modale")}
    >
      <div
        className="absolute w-full h-full top-0 left-0  bg-cover bg-center transition transform hover:duration-[6000ms] group-hover:scale-105 motion-reduce:transition-none motion-reduce:hover:transform-none pointer-events-none"
        style={{ backgroundImage: `url(${editorialBox.image.url}` }}
      ></div>

      <div>
        <Image
          src={"/assets/damac-d.svg"}
          alt={"damac"}
          width={56}
          height={32}
          className="w-[30px] h-[18px] md:w-[56px] md:h-[32px] mb-l mb:mb-0 aspect-3-4"
        />
      </div>
      <div className="text-white md:w-[60%] relative z-10">
        <h4 className="font-primary font-medium text-m mb-m uppercase">{editorialBox.title}</h4>
        <p className="text-s">{editorialBox.description}</p>
        <Button
          size={ButtonSize.SMALL}
          variant={ButtonVariant.PRIMARY}
          theme={ButtonTheme.WHITE}
          customClass="mt-m font-medium"
          onClick={() => console.log("modale")}
        >
          Start now
        </Button>
      </div>
    </button>
  );
};

export default EditorialBox;
